import { grey } from "@mui/material/colors";

const styles = {
  mobileNavigation: (discoverTabOpen: boolean) => ({
    display: "flex",
    alignItems: "center",
    pl: discoverTabOpen ? 2 : 0,
    pr: 2,
    ml: { xs: 0, md: "60px" },
    height: 60,
    borderBottom: "none",
  }),
  navigation: {
    position: "fixed",
    display: "flex",
    alignItems: "center",
    pl: 2,
    pr: 4,
    left: 80,
    right: 0,
    height: 60,
    borderBottom: "none",
  },
  menuButton: {
    fontSize: { xs: 12, md: 14 },
    px: 2,
  },
  activeMenuButton: {
    backgroundColor: "green.main",
    color: "white",
    "&:hover": {
      backgroundColor: "green.light",
    },
  },
  avatar: {
    backgroundColor: "#1b4332",
    color: "white",
    fontSize: { xs: 12, md: 11 },
    fontWeight: 600,
    width: { xs: 30, md: 32 },
    height: { xs: 30, md: 32 },
  },
  pillButton: {
    borderRadius: 9999,
    textTransform: "none",
    color: "#364153",
    borderColor: "#e5e7eb",
    fontSize: 12,
    fontWeight: 500,
    height: 30,
    px: 1.5,
    "&:hover": {
      borderColor: "#d1d5db",
      backgroundColor: "#f9fafb",
    },
  },
  icon: {
    color: "green.dark",
  },
  menuBarIcon: { color: "green.dark", fontSize: 16 },
  iconButton: { ml: 1, mr: 0, color: "green.dark", fontSize: 12 },
  bell: { color: "green.dark", fontSize: 18 },
  totalMessages: { color: grey[500] },
  sent: { color: "primary.main" },
  emailLeft: { fontSize: 10, color: grey[400], textTransform: "none" },
  emailsButton: { display: "block", textAlign: "center" },
  topBarLogo: { width: 50, mr: 1, cursor: "pointer" },
  name: {
    px: 2,
    pb: 1,
    fontSize: { xs: 12, md: 14 },
    color: "green.dark",
    fontWeight: "bold",
  },
  email: {
    px: 2,
    fontSize: { xs: 10, md: 12 },
    color: grey[500],
    pb: 0.5,
  },
};

export default styles;
